"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgChrono(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M16.085 0a.766.766 0 01.104 1.525l-.104.007-1.277-.001.001 2.583a9.905 9.905 0 015.143 1.913l1.719-1.718a.766.766 0 01.997-.074l.086.074 1.021 1.022a.766.766 0 01.075.997l-.075.086-1.718 1.718A9.913 9.913 0 0124 14.042c0 5.5-4.458 9.958-9.957 9.958a9.932 9.932 0 01-7.42-3.318.766.766 0 111.14-1.022 8.426 8.426 0 106.279-14.043A8.399 8.399 0 007.638 8.57a.766.766 0 11-1.164-.995 9.928 9.928 0 016.804-3.46l-.001-2.583H12a.766.766 0 01-.104-1.524L12 0h4.085zM5.872 16.34a.766.766 0 01.104 1.525l-.104.007H2.808a.766.766 0 01-.103-1.525l.103-.007h3.064zm5.068-6.472l.085.074 2.161 2.161a1.788 1.788 0 11.601 3.471 1.786 1.786 0 01-1.684-2.388l-2.16-2.16a.766.766 0 01.997-1.158zm-3.025 3.408a.766.766 0 01.104 1.525l-.104.007H1.787a.766.766 0 01-.104-1.525l.104-.007h6.128zM4.85 10.213a.766.766 0 01.104 1.525l-.104.007H.766a.766.766 0 01-.104-1.525l.104-.007H4.85z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgChrono;
exports.default = _default;